import React, { useState, useEffect, useContext } from 'react';


import SimpleTable from '../../components/tables/simpleTable';

import TrashModal from '../../components/modals/trashModal';
import RecoverModal from '../../components/modals/recoverModal';
import AddModal from '../../components/modals/addModal';
import EditModal from '../../components/modals/editModal';
import DeleteModal from '../../components/modals/deleteModal';

import SearchFilter from '../../components/filters/search';
import BalanceFilter from './balanceFilter';
import CustomButton from '../../components/buttons/customButton';
import IsActiveFilter from '../../components/filters/isActive';
import AddButton from '../../components/buttons/addButton';
import DataFilter from '../../components/filters/dataFilter';
import DatePicker from '../../components/filters/datePicker';

import { FaPlus } from "react-icons/fa";

import Loader from '../../components/loader/loader';
import { numberFormatter, totalFormatter } from '../../components/formatters/numberFormatter';
import { dateFormatter } from '../../dynamic/dateFormatter';
import { clientOrderColumnDefs } from '../../components/tables/columnDefs';
import toast from 'react-hot-toast';

import { Space, Input, Tag, Button, Tabs } from 'antd';


import Select from 'react-select';
import { Col, Form, Row, DropdownButton, Dropdown } from 'react-bootstrap';


import { FiEdit } from "react-icons/fi";
import { FcUndo, FcViewDetails, FcFlowChart, FcRules } from "react-icons/fc";
import { BiSolidTrash, BiBarcodeReader } from "react-icons/bi";
import { IoBarcodeOutline } from "react-icons/io5"; 
import { FcPlus } from "react-icons/fc";
import { HiMinusCircle } from "react-icons/hi";

import { DataContext } from '../../init/getData';




function Member(props) {

  let { type } = props;


  const { userData, settingData, serverApi, api } = useContext(DataContext);
  const userRole = userData.role;
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const createdBy = parseInt(userData.id);


  const [idRow, setIdRow] = useState([]);
  const [refreshTable, setRefreshTable] = useState(true);
  const [columnDefs, setColumnDefs] = useState([]);
  const [filter, setFilter] = useState({ search: '', isActive: 'true', type: 'member', balanceFilter: 'All', });

  const [showAddModal, setShowAddModal] = useState(false);
  const [showTrashModal, setShowTrashModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showRecoverModal, setShowRecoverModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);  
  const [filteredData, setFilteredData] = useState([]);
  const [balanceFilter, setBalanceFilter] = useState({ label: 'All', value: 'All' });



  
  useEffect(() => {
    console.log(data);
    if (balanceFilter.value === 'All') {
        setFilteredData(data); 
    } else if (balanceFilter.value === 'Below0') {
        const filtered = data?.data?.filter(item => numberFormatter(item.totalBalance) < 0) || [];   
        setFilteredData({
            ...data, 
            data: filtered 
        });
        console.log("filtered", filtered);
    }
}, [data, balanceFilter]);



  
  


 
  

  const [account, setAccount] = useState([]);

  const table = 'account';
  const title = 'Member';


  const addModal = () => {
    setIdRow({});
    resetForm();
    setShowAddModal(!showAddModal);
  }

  const resetForm = () => {
    setAccount({
      createdBy: createdBy,
      type: 'member',
      address: '',
      phone: '',
      barcode: '',
    })
  }

  const refreshTableFunction = () => {
    setRefreshTable(!refreshTable)
  }

  const recoverModal = (e) => {
    if (!showRecoverModal) {
      setIdRow(e);
    }
    setShowRecoverModal(!showRecoverModal);
  }

  const trashModal = (e) => {
    if (!showTrashModal) {
      setIdRow(e);
    }
    setShowTrashModal(!showTrashModal);
  }

  const deleteModal = (e) => {
    if (!showDeleteModal) {
      setIdRow(e);
    }
    setShowDeleteModal(!showDeleteModal);
  }

  const editModal = (e) => {
    if (!showEditModal) {
      setIdRow(e);
    }
    setShowEditModal(!showEditModal);
  }

  // idRow Change
  useEffect(() => {
    setAccount(
      {
        barcode: idRow?.barcode || '',
        name: idRow?.name || '',
        phone: idRow?.phone || '',
        address: idRow?.address || '',
        createdBy: createdBy,
        type: 'member',
      }
    )
  }, [idRow]);


  // Generic handler for input changes
  const handleInputChange = (e) => {
    let { name, value } = e.target;
    if (value === 'true' || value === 'false') {
      value = JSON.parse(value)
    }
    setAccount((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  

  


  //Excel Data
  const getExcelData = (data) => {

    const transformedData = [];
    data.forEach(item => {

      const newItem = {
        id: item.id,
        barcode: item.barcode,
        name: item.name,
        phone: item.phone,
        address: item.address,
        balance: item.totalBalance,
      };

      transformedData.push(newItem);
    });

    return transformedData; 
  };

 

  


  let newColumnDefs = [
    { title: 'ID', dataIndex: 'id', width: '5%' },
    { title: 'Barcode', dataIndex: 'barcode' },
    { title: 'Name', dataIndex: 'name' },
    { title: 'Phone', dataIndex: 'phone' },
    { title: 'Address', dataIndex: 'address' },  
    { title: 'Balance', dataIndex: 'totalBalance', render: numberFormatter },
  ];

  useEffect(() => {
  
    if (filter.isActive == 'true') {
      newColumnDefs.push(
        {
          title: 'Edt',
          width: '5%',
          render: (_, record) => (
            <FiEdit size={16} style={{ cursor: 'pointer', color: '#2E70A5' }} onClick={() => editModal(record)} />
          ),
        },
        {
          title: 'Del',
          width: '5%',
          render: (_, record) => (
            <BiSolidTrash size={18} style={{ cursor: 'pointer', color: '#e6434f' }} onClick={() => trashModal(record)} />
          ),
        }
      );
    } else {
      newColumnDefs.push({
        title: 'Rec',
        width: '5%',
        render: (_, record) => (
          <FcUndo size={20} style={{ cursor: 'pointer' }} onClick={() => recoverModal(record)} />
        ),
      });
    }
    setColumnDefs(newColumnDefs);

  }, [filter.isActive]);

  const formView = (
    <div style={{ userSelect: 'none' }}>
      <Row className="mb-3">
        {/* Hidden Type Field */}
        <Form.Control type="hidden" name="type" value="member" />

        {/* Barcode */}
        <Form.Group as={Col} md={6}>
          <Form.Label className="formLabel">
            <IoBarcodeOutline size={25} /> Barcode
          </Form.Label>
          <Form.Control
            type="text"
            name="barcode"
            placeholder="optional"
            value={account?.barcode || ''}
            onChange={handleInputChange}
          />
        </Form.Group>

        {/* Name */}
        <Form.Group as={Col} md={6}>
          <Form.Label className="formLabel">
            Name<span style={{ color: 'red' }}> *</span>
          </Form.Label>
          <Form.Control
            type="text"
            name="name"
            value={account.name}
            onChange={handleInputChange}
            required
          />
        </Form.Group>
      </Row>

      <Row className="mb-3">
        {/* Phone */}
        <Form.Group as={Col} md={6}>
          <Form.Label className="formLabel">
            Phone<span style={{ color: 'red' }}> *</span>
          </Form.Label>
          <Form.Control
            type="text"
            name="phone"
            value={account.phone}
            onChange={handleInputChange}
            required
          />
        </Form.Group>

        {/* Address */}
        <Form.Group as={Col} md={6}>
          <Form.Label className="formLabel">
            Address<span style={{ color: 'red' }}> *</span>
          </Form.Label>
          <Form.Control
            as="textarea"
            name="address"
            value={account.address}
            onChange={handleInputChange}
          />
        </Form.Group>
      </Row>
    </div>
  );


  const modalFooter = (
    <div>
    </div>
  );

  const tableFooter = (
    <></>
  );




  return (
    <div className='card'>

      {isLoading &&
        <Loader />
      }


      {!isLoading &&
        <>
          <div>

            <SearchFilter setFilter={setFilter} />
            <IsActiveFilter setFilter={setFilter} />
            <select 
              className="form-control dropDown" 
              value={balanceFilter.value}
              onChange={(e) => {
                const selectedValue = e.target.value;
                console.log('Selected balance filter:', selectedValue);
                setBalanceFilter({ label: selectedValue, value: selectedValue });
              }}
            >
              <option value="All">All</option>
              <option value="Below0">Below 0</option>
            </select>



            <AddButton addModal={addModal} />

          </div>



          <SimpleTable
            filter={filter}
            showAddModal={showAddModal}
            addModal={addModal}
            table={table}
            title={title}
            columnDefs={columnDefs}
            idRow={idRow}
            setIdRow={setIdRow}
            refreshTable={refreshTable}
            data={filteredData}
            setData={setData}
            tableFooter={tableFooter}
            api={api}
            getExcelData={getExcelData}
          />

          <TrashModal
            showModal={showTrashModal}
            toggleModal={trashModal}
            idRow={idRow}
            table={table}
            title={title}
            refreshTable={refreshTableFunction}
            api={api}
            data={{ id: idRow.id }}
          />

          <RecoverModal
            showModal={showRecoverModal}
            toggleModal={recoverModal}
            idRow={idRow}
            table={table}
            title={title}
            refreshTable={refreshTableFunction}
            api={api}
          />

          <AddModal
            showModal={showAddModal}
            toggleModal={addModal}
            formView={formView}
            idRow={idRow}
            table={table}
            title={title}
            refreshTable={refreshTableFunction}
            size={'lg'}
            resetForm={resetForm}
            footer={modalFooter}
            api={api}
            data={{ account }}
          />

          <EditModal
            showModal={showEditModal}
            toggleModal={editModal}
            formView={formView}
            idRow={idRow}
            table={table}
            title={title}
            refreshTable={refreshTableFunction}
            size={'lg'}
            footer={modalFooter}
            api={api}
            data={{ id: idRow?.id, account }}
          />


        </>
      }

    </div>
  )
}

export default Member;
